import { createSlice } from "@reduxjs/toolkit";

const INITIAL_STATE = {
    time: "",
};

const plotEvent = createSlice({
    name: "plotEvent",
    initialState: INITIAL_STATE,
    reducers: {
        setPlotEventTime(state, action) {
            return {
                ...state,
                time: action.payload,
            };
        },
    },
});

export const plotEventActions = plotEvent.actions;

export default plotEvent;
